import { render, staticRenderFns } from "./module-list.vue?vue&type=template&id=3ffc4806&scoped=true&"
import script from "./module-list.vue?vue&type=script&lang=js&"
export * from "./module-list.vue?vue&type=script&lang=js&"
import style0 from "./module-list.vue?vue&type=style&index=0&id=3ffc4806&lang=scss&scoped=true&"
import style1 from "./module-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc4806",
  null
  
)

export default component.exports